var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.to && _vm.to.indexOf('http') != -1 )?_c('a',{attrs:{"href":_vm.to,"target":_vm.target}},[_vm._t("default")],2):_c('router-link',_vm._b({},'router-link',_vm.vProps,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }